import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import cancel_45loader_45global from "/vercel/path0/middleware/cancelLoader.global.ts";
import clear_45modals_45global from "/vercel/path0/middleware/clearModals.global.ts";
import page_45change_45scroll_45global from "/vercel/path0/middleware/pageChangeScroll.global.ts";
import save_45routes_45global from "/vercel/path0/middleware/saveRoutes.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  cancel_45loader_45global,
  clear_45modals_45global,
  page_45change_45scroll_45global,
  save_45routes_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-offline": () => import("/vercel/path0/middleware/checkOffline.ts")
}